/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Simple_Kits_TitleInputs */

const en_simple_kits_title = /** @type {(inputs: Simple_Kits_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick the one closest to what you need`)
};

const id_simple_kits_title = /** @type {(inputs: Simple_Kits_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilih yang paling mirip kebutuhanmu`)
};

/**
* | output |
* | --- |
* | "Pick the one closest to what you need" |
*
* @param {Simple_Kits_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const simple_kits_title = /** @type {((inputs?: Simple_Kits_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Simple_Kits_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_simple_kits_title(inputs)
	return en_simple_kits_title(inputs)
});